module.exports = __webpack_public_path__ + "img/school.80556b9e.png";